import { Injectable } from '@angular/core';
import { UiGrecaptcha } from './recaptcha.types';

const SCRIPT_ID = 'ui-recaptcha-script';
const SCRIPT_BASE_URL = 'https://www.google.com/recaptcha/api.js';

/**
 * Cargador idempotente del script de Google reCAPTCHA v2.
 * Se carga una sola vez por documento; resuelve cuando `grecaptcha.ready` está disponible.
 */
@Injectable({ providedIn: 'root' })
export class UiRecaptchaLoaderService {
  private loaderPromise: Promise<UiGrecaptcha> | null = null;

  load(language = 'es'): Promise<UiGrecaptcha> {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return Promise.reject(new Error('reCAPTCHA requires a browser environment.'));
    }

    if (this.loaderPromise) return this.loaderPromise;

    this.loaderPromise = new Promise<UiGrecaptcha>((resolve, reject) => {
      const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;

      const waitForReady = () => {
        const g = window.grecaptcha;
        if (!g || typeof g.ready !== 'function') {
          setTimeout(waitForReady, 50);
          return;
        }
        g.ready(() => resolve(g));
      };

      if (existing) {
        waitForReady();
        return;
      }

      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = `${SCRIPT_BASE_URL}?hl=${encodeURIComponent(language)}&render=explicit`;
      script.async = true;
      script.defer = true;
      script.onerror = () => {
        this.loaderPromise = null;
        reject(new Error('No se pudo cargar el script de reCAPTCHA.'));
      };
      script.onload = () => waitForReady();
      document.head.appendChild(script);
    });

    return this.loaderPromise;
  }
}
